module.exports = __webpack_public_path__ + "img/1MGPeJ_y5qwYBuAC47njQ2eqwzgDHi8em.1c86acac.jpg";